module.exports = __webpack_public_path__ + "static/media/list-thumbnail.f66e5da3.png";